import React from 'react';

const PorCarouselItem = (props) => {
  const { brand, image } = props;

  return (
    <div className="carousel-item por-carousel-item">
      <a href={`/por-deals?brand_id=${brand.id}`} className="overlay">
        { brand && <div className="por-deal">{brand.name}</div> }
        <div>
          <div className="more-information">Click to find out more</div>
        </div>
      </a>
      <img src={image} alt='' />
    </div>
  );
};

export default PorCarouselItem;



// WEBPACK FOOTER //
// ./src/components/common/home/carousels/por-carousel-item.jsx